import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { RoundedPlusIcon } from "../../../ui/icons/RoundedPlusIcon"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { Banner } from "../../../ui/organisms/banner"
import { formatterDate, OptionType } from "../../../utils"
import { resetGetAllOdcStatus } from "../../odc/slice"
import { OtherOdcMeasuresResponseDataDTO } from "./dataService/dto"
import { GetAllCustomerNewMeasure, GetAllCustomerOldMeasure, setDescriptionsAreaCode, setMeasureVersion, setOtherOdcMeasureDescription, setOtherOdcMeasureFiltersCodexReleased, setOtherOdcMeasureFiltersCustomerId, setOtherOdcMeasureIsReleased, setOtherOdcMeasureNonComplianceDescription, setOtherOdcMeasureNonComplianceOfficerId, setOtherOdcMeasuresCustomerId, setOtherOdcMeasuresDate, setOtherOdcMeasureSelected, setOtherOdcMeasuresNonComplianceCode, setOtherOdcMeasuresOdc, setOtherOdcNewMeasureDescription, setOtherOdcNewMeasureFiltersCodexReleased, setOtherOdcNewMeasureFiltersCustomerId, setOtherOdcNewMeasureIsReleased, setOtherOdcNewMeasureNonComplianceDescription, setOtherOdcNewMeasureNonComplianceOfficerId, setOtherOdcNewMeasuresCustomerId, setOtherOdcNewMeasuresDate, setOtherOdcNewMeasuresNewComplianceCode, setOtherOdcNewMeasuresNonComplianceVersion, setOtherOdcNewMeasuresOdc } from "./dataService/slice"

export function CustomerOtherOdcList() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const OtherOdcMeasuresState = useAppSelector(state => state.OtherOdcMeasuresState)
    const odcState = useAppSelector(state => state.odc)
    const sessionState = useAppSelector(state => state.session)
    const [odc, setOdc] = useState<OptionType[]>([])

    useEffect(() => {
        dispatch(setOtherOdcNewMeasureFiltersCodexReleased(false))
        dispatch(setOtherOdcMeasureFiltersCodexReleased(false))
        dispatch(setOtherOdcMeasureFiltersCustomerId(sessionState.selected.customerId))
        dispatch(setOtherOdcNewMeasureFiltersCustomerId(sessionState.selected.customerId))
    })

    useEffect(() => {
        if (sessionState.selected.customerId) {
            dispatch(GetAllCustomerOldMeasure({ customerId: sessionState.selected.customerId, isCodexReleased: false }))
            dispatch(GetAllCustomerNewMeasure({ customerId: sessionState.selected.customerId, isCodexReleased: false }))
        }
    }, [])

    useEffect(() => {
        if (odcState.getAllOdcStatus === 'successfully' && odcState.getAllOdcResponse !== undefined) {
            dispatch(resetGetAllOdcStatus())
            setOdc(odcState.getAllOdcResponse.data.map(o => ({ value: o.id, label: o.code + ' - ' + o.companyName } as OptionType)))
        }
    }, [odcState.getAllOdcStatus])

    const onEditHandleOld = (measure: OtherOdcMeasuresResponseDataDTO) => {
        dispatch(setMeasureVersion('old'))
        dispatch(setOtherOdcMeasureSelected(measure.id))
        dispatch(setOtherOdcMeasureIsReleased(measure.isCodexRealesed))
        dispatch(setOtherOdcMeasuresDate(measure.measureDate))
        dispatch(setOtherOdcMeasuresOdc(measure.odcId))
        dispatch(setOtherOdcMeasuresCustomerId(measure.customerId))
        dispatch(setOtherOdcMeasuresNonComplianceCode(measure.nonComplianceDTO.nonComplianceCode))
        dispatch(setOtherOdcMeasureNonComplianceDescription(measure.nonComplianceDescription))
        dispatch(setOtherOdcMeasureDescription(measure.measureDescription))
        dispatch(setOtherOdcMeasureNonComplianceOfficerId(measure.officerId))
        navigate('/editProvvedimentoAltroOdc')
    }

    const onEditHandleNew = (measure: OtherOdcMeasuresResponseDataDTO) => {
        dispatch(setMeasureVersion('new'))
        dispatch(setOtherOdcNewMeasuresNonComplianceVersion('NEW'))
        dispatch(setOtherOdcMeasureSelected(measure.id))
        dispatch(setOtherOdcNewMeasuresCustomerId(sessionState.selected.customerId))
        dispatch(setOtherOdcNewMeasureIsReleased(false))
        dispatch(setOtherOdcNewMeasureNonComplianceOfficerId(sessionState.selected.officerId))
        dispatch(setOtherOdcNewMeasuresDate(measure.measureDate))
        dispatch(setOtherOdcNewMeasuresOdc(measure.odcId))
        dispatch(setOtherOdcNewMeasuresNewComplianceCode(measure.odcId))
        dispatch(setOtherOdcNewMeasureNonComplianceDescription(measure.nonComplianceDescription))
        dispatch(setOtherOdcNewMeasureDescription(measure.measureDescription))
        dispatch(setDescriptionsAreaCode(measure.newNonComplianceCodeDTO))
        navigate('/editProvvedimentoAltroOdc')
    }

    if (sessionState.selected.customerId) {
        return (
            <div className="p-6 flex flex-col gap-4">
                <div className="flex justify-end">
                    <ButtonComponent
                        variant="solid"
                        disabled={!sessionState.selected.customerId}
                        size="md"
                        color="orange"
                        iconPosition="left"
                        icon={<RoundedPlusIcon />}
                        label="Crea nuovo"
                        onClick={() => navigate('/creaProvvedimentoAltroOdc')}
                    />
                </div>

                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-text-md min-w-[900px]">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Data Provvedimento</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">OdC</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Codice N.C.</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Descrizione NC</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Descrizione Provvedimento</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[72px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {OtherOdcMeasuresState.OtherOdcMeasureResponse.data?.map((measure, index) => (
                                <tr key={`old-${index}`} className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(measure.measureDate)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{measure.odcInfo}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{measure.nonComplianceDTO.nonComplianceCode}</td>
                                    <td className="px-3 py-2 text-neutral-700">{measure.nonComplianceDescription}</td>
                                    <td className="px-3 py-2 text-neutral-700">{measure.measureDescription}</td>
                                    <td className="px-3 py-2 w-[72px]">
                                        <div className="flex justify-center">
                                            <button className="p-1 rounded hover:bg-neutral-100 transition-colors" onClick={() => onEditHandleOld(measure)}>
                                                <EditIcon color="orange" size={18} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {OtherOdcMeasuresState.OtherOdcNewMeasureResponse.data?.map((measure, index) => (
                                <tr key={`new-${index}`} className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(measure.measureDate)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{measure.odcInfo}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                        {measure.newNonComplianceCodeDTO && <span>{measure.newNonComplianceCodeDTO.nonComplianceCode}</span>}
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700">{measure.nonComplianceDescription}</td>
                                    <td className="px-3 py-2 text-neutral-700">{measure.measureDescription}</td>
                                    <td className="px-3 py-2 w-[72px]">
                                        <div className="flex justify-center">
                                            <button className="p-1 rounded hover:bg-neutral-100 transition-colors" onClick={() => onEditHandleNew(measure)}>
                                                <EditIcon color="orange" size={18} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {!OtherOdcMeasuresState.OtherOdcMeasureResponse.data?.length && !OtherOdcMeasuresState.OtherOdcNewMeasureResponse.data?.length && (
                                <tr><td colSpan={6} className="px-3 py-3 text-left text-neutral-500 bg-white">Nessun provvedimento trovato</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    return (
        <div className="p-6">
            <Banner type="error" visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'elenco"}
                closeAction={() => alert("Devi prima selezionare un cliente per accedere all'elenco")}
            />
        </div>
    )
}